import { useEffect, useState } from 'react';
import { getOfflineQueueCount, subscribeToOfflineQueue } from '../lib/offlineQueue';

export function useOfflineQueueCount() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let cancelled = false;

    async function refreshCount() {
      try {
        const nextCount = await getOfflineQueueCount();
        if (!cancelled) {
          setCount(nextCount);
        }
      } catch {
        if (!cancelled) {
          setCount(0);
        }
      }
    }

    refreshCount();
    const unsubscribe = subscribeToOfflineQueue(refreshCount);
    window.addEventListener('online', refreshCount);
    window.addEventListener('offline', refreshCount);

    return () => {
      cancelled = true;
      unsubscribe();
      window.removeEventListener('online', refreshCount);
      window.removeEventListener('offline', refreshCount);
    };
  }, []);

  return count;
}
